// M-7 slice C: self-service access request (public — sends initData, no JWT).
import { apiRequest } from './client'
import { MOCK } from '../dev/mock'
import { getWebApp } from '../telegram/tg'

export interface RequestAccessPayload {
  name: string
  bitrix_login_hint?: string
  tenant_slug_hint?: string
  comment?: string
}

export interface RequestAccessResult {
  ok: boolean
  request_id: string
  estimated_review_hours: number
}

export function requestAccess(p: RequestAccessPayload): Promise<RequestAccessResult> {
  if (MOCK) return Promise.resolve({ ok: true, request_id: 'mock', estimated_review_hours: 24 })
  const initData = getWebApp()?.initData ?? ''
  return apiRequest<RequestAccessResult>('/api/miniapp/request-access', {
    method: 'POST',
    unauthenticated: true,
    body: { ...p, initData },
  })
}
